if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalItems = Array.from(this.querySelector('.product-media-modal__content')?.children || []).filter(
          (item) => item.dataset.mediaId
        );
        this.modalPreviews = Array.from(this.querySelectorAll('[data-modal-media-id]'));
        this.querySelectorAll('.product-media-modal__navigation, .product-media-modal__previews').forEach((controls) => {
          controls.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.querySelector('.product-media-modal__arrow--prev')?.addEventListener('click', () =>
          this.showModalItem(this.modalCurrent - 1)
        );
        this.querySelector('.product-media-modal__arrow--next')?.addEventListener('click', () =>
          this.showModalItem(this.modalCurrent + 1)
        );
        this.modalPreviews.forEach((preview) => {
          preview.addEventListener('click', () => {
            const index = this.modalItems.findIndex((item) => item.dataset.mediaId === preview.dataset.modalMediaId);
            if (index >= 0) this.showModalItem(index);
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeIndex = Math.max(
          0,
          this.modalItems.findIndex((item) => item.dataset.mediaId === mediaId)
        );
        this.showModalItem(activeIndex);
      }

      showModalItem(index) {
        if (!this.modalItems.length) return;
        this.modalCurrent = ((index % this.modalItems.length) + this.modalItems.length) % this.modalItems.length;
        const activeMedia = this.modalItems[this.modalCurrent];

        this.modalItems.forEach((item, itemIndex) => {
          const active = itemIndex === this.modalCurrent;
          item.classList.toggle('active', active);
          item.hidden = !active;
        });
        this.modalPreviews.forEach((preview) => {
          if (preview.dataset.modalMediaId === activeMedia.dataset.mediaId) preview.setAttribute('aria-current', 'true');
          else preview.removeAttribute('aria-current');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
